import { alignUp } from './columnWriter'
import { fromTaggedJson, toTaggedJson } from '../taggedJson'
import { LapsFormatError } from './lapsFormatError'

const MAGIC = 'PBL1'
const HEADER_LENGTH_OFFSET = 4
const PREFIX_BYTES = 8
const TEXT_CHUNK = 8192

export function writeLayout(header: object, columns: Uint8Array): Uint8Array {
  assertLittleEndianHost()
  const headerText = toTaggedJson(header)
  const dataStart = alignUp(PREFIX_BYTES + headerText.length)
  const bytes = new Uint8Array(dataStart + columns.byteLength)
  writeAscii(bytes, 0, MAGIC)
  new DataView(bytes.buffer).setUint32(
    HEADER_LENGTH_OFFSET,
    headerText.length,
    true
  )
  writeAscii(bytes, PREFIX_BYTES, headerText)
  bytes.set(columns, dataStart)
  return bytes
}

export function readLayout(bytes: Uint8Array): {
  header: unknown
  data: ArrayBuffer
} {
  assertLittleEndianHost()
  if (
    bytes.byteLength < PREFIX_BYTES ||
    readAscii(bytes, 0, MAGIC.length) !== MAGIC
  ) {
    throw new LapsFormatError(`not a ${MAGIC} laps file`)
  }
  const headerLength = new DataView(
    bytes.buffer,
    bytes.byteOffset,
    bytes.byteLength
  ).getUint32(HEADER_LENGTH_OFFSET, true)
  const headerEnd = PREFIX_BYTES + headerLength
  if (headerEnd > bytes.byteLength) {
    throw new LapsFormatError('the header runs past the end of the file')
  }
  const header = parseHeader(readAscii(bytes, PREFIX_BYTES, headerEnd))
  const data = new Uint8Array(bytes.subarray(alignUp(headerEnd))).buffer
  return { header, data }
}

function parseHeader(text: string): unknown {
  try {
    return fromTaggedJson(text)
  } catch {
    throw new LapsFormatError('the header is not valid JSON')
  }
}

function writeAscii(bytes: Uint8Array, at: number, text: string): void {
  for (let i = 0; i < text.length; i++) bytes[at + i] = text.charCodeAt(i)
}

function readAscii(bytes: Uint8Array, start: number, end: number): string {
  let text = ''
  for (let at = start; at < end; at += TEXT_CHUNK) {
    const chunk = bytes.subarray(at, Math.min(end, at + TEXT_CHUNK))
    text += String.fromCharCode(...chunk)
  }
  return text
}

function assertLittleEndianHost(): void {
  if (new Uint8Array(Uint16Array.of(1).buffer)[0] !== 1) {
    throw new LapsFormatError('the laps format needs a little-endian host')
  }
}
